// extracted by mini-css-extract-plugin
export default {"iconButton":"a3psV1"};